(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1344],{

/***/ 35492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export splitValueIntoParts */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23795);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_6__);
/* eslint-disable jsx-a11y/anchor-is-valid */ 






var SPACE_CHAR = " ";
var WHITE_SPACE_REGEXP = /\s*$/;
var DOUBLE_QUOTES = '"';
var splitValueIntoParts = function(value, charLimit) {
    if (!value) {
        return {
            teaser: value
        };
    }
    var remainingWords = [];
    var teaserWords = value.split(SPACE_CHAR);
    while(teaserWords.join(SPACE_CHAR).length > charLimit){
        remainingWords.unshift(teaserWords.pop());
    }
    return {
        teaser: teaserWords.join(SPACE_CHAR),
        remaining: remainingWords.join(SPACE_CHAR)
    };
};
var ReadMore = function(_param) {
    var value = _param.value, _charLimit = _param.charLimit, charLimit = _charLimit === void 0 ? 500 : _charLimit, _ellipses = _param.ellipses, ellipses = _ellipses === void 0 ? "..." : _ellipses, _showLessButton = _param.showLessButton, showLessButton = _showLessButton === void 0 ? true : _showLessButton, _showDoubleQuotes = _param.showDoubleQuotes, showDoubleQuotes = _showDoubleQuotes === void 0 ? false : _showDoubleQuotes, _onShowMoreClick = _param.onShowMoreClick, onShowMoreClick = _onShowMoreClick === void 0 ? function() {} : _onShowMoreClick, _onShowLessClick = _param.onShowLessClick, onShowLessClick = _onShowLessClick === void 0 ? function() {} : _onShowLessClick, _showMoreLabel = _param.showMoreLabel, showMoreLabel = _showMoreLabel === void 0 ? "more" : _showMoreLabel, _showLessLabel = _param.showLessLabel, showLessLabel = _showLessLabel === void 0 ? "less" : _showLessLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "value",
        "charLimit",
        "ellipses",
        "showLessButton",
        "showDoubleQuotes",
        "onShowMoreClick",
        "onShowLessClick",
        "showMoreLabel",
        "showLessLabel"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var handleToggle = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setIsExpanded(!isExpanded);
        if (isExpanded) {
            onShowLessClick();
        } else {
            onShowMoreClick();
        }
    }, [
        isExpanded,
        onShowMoreClick,
        onShowLessClick
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return splitValueIntoParts(value, charLimit);
    }, [
        value,
        charLimit
    ]), teaser = ref1.teaser, remaining = ref1.remaining;
    var canBeToggled = value.length > charLimit;
    var splitContent = !isExpanded ? "".concat(teaser.replace(WHITE_SPACE_REGEXP, "")) : "".concat(teaser, " ").concat(remaining);
    var content = canBeToggled ? splitContent : value;
    var toggleLabel = isExpanded ? "".concat(showLessLabel) : "".concat(showMoreLabel);
    var hideToggle = canBeToggled && (!isExpanded || showLessButton);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        children: [
            showDoubleQuotes && "".concat(DOUBLE_QUOTES),
            content,
            showDoubleQuotes && !hideToggle && "".concat(DOUBLE_QUOTES),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("noscript", {
                dangerouslySetInnerHTML: {
                    __html: remaining ? sanitize_html__WEBPACK_IMPORTED_MODULE_6___default()(remaining) : ""
                }
            }),
            hideToggle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    isExpanded && showDoubleQuotes && "".concat(DOUBLE_QUOTES),
                    isExpanded && "".concat(SPACE_CHAR),
                    !isExpanded && "".concat(ellipses).concat(SPACE_CHAR),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        sx: {
                            font: "inherit",
                            verticalAlign: "inherit",
                            textDecoration: "underline"
                        },
                        component: "button",
                        onClick: handleToggle,
                        children: toggleLabel
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ReadMore);


/***/ }),

/***/ 58291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61730);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
/* eslint-disable no-nested-ternary */ 



var SeoConversionBox = function(param) {
    var city = param.city, crossSell = param.crossSell, enrollmentURL = param.enrollmentURL, header = param.header, pageType = param.pageType, resultType = param.resultType, serviceId = param.serviceId, state = param.state;
    var isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var isCCProvider = typeof resultType !== "undefined" && _constants__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULT_TYPE */ .sM[resultType] === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULT_TYPE.PROVIDER */ .sM.PROVIDER && serviceId === "CHILDCARE" && crossSell;
    var avgPayRates = crossSell === null || crossSell === void 0 ? void 0 : crossSell.avgPayRates;
    var handleCareButton = function(e) {
        var ref;
        var amplitudeData = {
            cta_location: "header",
            cta_text: (ref = e.target.textContent) === null || ref === void 0 ? void 0 : ref.toString(),
            cta_type: "button"
        };
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.ctaInteracted */ .Sj.ctaInteracted, amplitudeData);
    };
    var renderHeading = function() {
        if (isCCProvider) {
            return "Find other affordable childcare options" + "".concat(pageType === "LOCAL" ? " near you in ".concat(city, ", ").concat(state) : " in your area");
        }
        return header;
    };
    var renderCtaBtns = function() {
        if (isCCProvider) {
            return avgPayRates === null || avgPayRates === void 0 ? void 0 : avgPayRates.map(function(param) {
                var title = param.title, url = param.url, avgPayRate = param.avgPayRate;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    minWidth: "200px",
                    mx: 1.5,
                    mt: 1.5,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        component: "a",
                        href: url,
                        variant: "contained",
                        size: "large",
                        fullWidth: true,
                        color: "secondary",
                        "data-testid": "conversion-cta-link",
                        onClick: handleCareButton,
                        children: [
                            title,
                            " $",
                            parseFloat(avgPayRate.rate.amount).toFixed(2),
                            "/",
                            _constants__WEBPACK_IMPORTED_MODULE_1__/* .RATE_DURATION_ABBREVIATIONS */ .r7[avgPayRate.rateDuration]
                        ]
                    })
                }, title);
            });
        }
        return _constants__WEBPACK_IMPORTED_MODULE_1__/* .CONVERSION_CTA_LABELS.map */ .dA.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                minWidth: "144px",
                mt: 1.5,
                mx: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    component: "a",
                    href: "".concat(enrollmentURL, "&intent=").concat(item.intent),
                    variant: "contained",
                    color: "secondary",
                    size: "medium",
                    sx: {
                        fontSize: "16px"
                    },
                    fullWidth: true,
                    "data-testid": "conversion-cta-link",
                    onClick: handleCareButton,
                    rel: "nofollow",
                    children: item.label
                })
            }, item.intent);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
        container: true,
        bgcolor: function(theme) {
            return theme.palette.care.grey[100];
        },
        py: {
            xs: 3,
            sm: 5
        },
        px: 0,
        ml: "auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    mb: 1,
                    textAlign: "center",
                    component: "h3",
                    variant: "h2",
                    children: renderHeading()
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "center",
                flexWrap: !isMobile ? "nowrap" : "wrap",
                flexBasis: "100%",
                children: renderCtaBtns()
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoConversionBox);


/***/ }),

/***/ 19500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63880);

function useFeatureFlag(flagName) {
    var ref;
    var featureFlags = (0,_components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_0__/* .useFeatureFlags */ .g)();
    return featureFlags === null || featureFlags === void 0 ? void 0 : (ref = featureFlags.flags) === null || ref === void 0 ? void 0 : ref[flagName];
}


/***/ }),

/***/ 42200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ caregiver_CaregiverDetail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 12 modules
var CoreGlobalFooter = __webpack_require__(11566);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Divider/Divider.js
var Divider = __webpack_require__(81956);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/hooks/useActiveTheme.js
var useActiveTheme = __webpack_require__(56721);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/ProfileAvatar/ProfileAvatar.js + 3 modules
var ProfileAvatar = __webpack_require__(90346);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Rating/Rating.js + 6 modules
var Rating = __webpack_require__(25628);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Badge/Badge.js
var Badge = __webpack_require__(23887);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoBgcFilled.js
var Icon24InfoBgcFilled = __webpack_require__(66871);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon24ShieldFilled.js
var Icon24ShieldFilled = __webpack_require__(69336);
// EXTERNAL MODULE: ./src/utils/getUserInitials.ts
var getUserInitials = __webpack_require__(7772);
// EXTERNAL MODULE: ./src/utils/payRangeHelper.ts
var payRangeHelper = __webpack_require__(32150);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/components/hooks/useFeatureFlag.ts
var useFeatureFlag = __webpack_require__(19500);
// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(387);
;// CONCATENATED MODULE: ./src/components/hooks/useBackgroundCheckModal.tsx





var useBackgroundCheckModal = function(openModal) {
    var ref = (0,react.useState)(openModal), open = ref[0], setOpen = ref[1];
    var BadgeModal = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            open: open,
            variant: "dynamic",
            hideClose: true,
            onClose: function() {
                setOpen(false);
            },
            title: "Background Check",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    mb: 3,
                    textAlign: "left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoBgcFilled/* default */.Z, {
                                size: "18px"
                            }),
                            text: "Background Check"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body3",
                            color: "primary",
                            children: "Has a current Criminal and/or Motor Vehicles Records background check."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            variant: "body3",
                            href: "https://www.care.com/vis/safetyBackgroundChecks",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Learn about background check limitations"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    color: "secondary",
                    variant: "contained",
                    size: "small",
                    sx: {
                        display: "block",
                        margin: "auto"
                    },
                    onClick: function() {
                        setOpen(false);
                    },
                    children: "Close"
                })
            ]
        });
    };
    return [
        BadgeModal,
        setOpen,
        open
    ];
};
/* harmony default export */ var hooks_useBackgroundCheckModal = (useBackgroundCheckModal);

// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
;// CONCATENATED MODULE: ./src/components/Profile.tsx

















var getClasses = function(yearsOfExperience) {
    return {
        profileContainer: function(theme) {
            return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
                maxWidth: "780px",
                padding: theme.spacing(0, 3)
            });
        },
        profileImgSection: function(theme) {
            return (0,_define_property/* default */.Z)({
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: theme.spacing(4)
            }, theme.breakpoints.up("md"), {
                marginTop: theme.spacing(0),
                maxWidth: "315px",
                justifyContent: "flex-start"
            });
        },
        profileImgCustomBig: function(theme) {
            return {
                "& .MuiAvatar-root": (0,_define_property/* default */.Z)({
                    width: "120px",
                    height: "120px",
                    fontSize: "48px"
                }, theme.breakpoints.up("md"), {
                    width: "288px",
                    height: "288px",
                    fontSize: "72px"
                })
            };
        },
        profileAvailability: function(theme) {
            var ref;
            return {
                color: (ref = theme.palette.care) === null || ref === void 0 ? void 0 : ref.grey[600]
            };
        },
        profileInfoSection: function(theme) {
            return (0,_define_property/* default */.Z)({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }, theme.breakpoints.up("md"), {
                justifyContent: "flex-start",
                maxWidth: "300px"
            });
        },
        ageAndExpContainer: {
            maxWidth: "200px"
        },
        ageAndExp: function(theme) {
            var ref;
            var _obj;
            return _obj = {
                borderRight: yearsOfExperience > 0 ? "2px solid ".concat((ref = theme.palette.care) === null || ref === void 0 ? void 0 : ref.grey[300]) : "none",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: theme.spacing(2)
            }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
                alignItems: "flex-start"
            }), (0,_define_property/* default */.Z)(_obj, "&:last-of-type", (0,_define_property/* default */.Z)({
                borderRight: "0"
            }, theme.breakpoints.up("md"), {
                alignItems: "center"
            })), _obj;
        },
        bgcButton: {
            padding: 0,
            height: "inherit",
            width: "inherit"
        },
        careBadge: function(theme) {
            return (0,_define_property/* default */.Z)({
                justifyContent: "center",
                display: "flex",
                cursor: "pointer",
                marginTop: theme.spacing(1.8),
                "& a:focus": {
                    outline: "none"
                }
            }, theme.breakpoints.up("md"), {
                justifyContent: "left"
            });
        },
        profileInfo: function(theme) {
            return (0,_define_property/* default */.Z)({
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                margin: theme.spacing(1)
            }, theme.breakpoints.up("md"), {
                margin: theme.spacing(5, "auto"),
                width: "290px",
                textAlign: "left",
                alignItems: "flex-start"
            });
        },
        profileTitle: function(theme) {
            return (0,_define_property/* default */.Z)({
                marginTop: theme.spacing(1)
            }, theme.breakpoints.up("md"), {
                marginBottom: theme.spacing(0)
            });
        },
        profileRating: function(theme) {
            return {
                margin: theme.spacing(1.25),
                display: "flex",
                marginLeft: "0"
            };
        },
        ratingStars: {
            fontSize: "16px"
        },
        joinBtn: function(theme) {
            return (0,_define_property/* default */.Z)({
                minWidth: "215px",
                width: "auto",
                marginTop: theme.spacing(3)
            }, theme.breakpoints.up("md"), {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(1)
            });
        }
    };
};
var Profile = function(param) {
    var displayName = param.displayName, firstName = param.firstName, hiResImageURL = param.hiResImageURL, address = param.address, joinNowURL = param.joinNowURL, hasCareCheck = param.hasCareCheck, yearsOfExperience = param.yearsOfExperience, numberOfReviews = param.numberOfReviews, avgReviewRating = param.avgReviewRating, payRange = param.payRange, availability = param.availability;
    var classes = getClasses(yearsOfExperience);
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), serviceIdForMember = ref.serviceIdForMember, pageType = ref.pageType;
    var ref1 = (0,_sliced_to_array/* default */.Z)(hooks_useBackgroundCheckModal(false), 2), BadgeModal = ref1[0], setOpen = ref1[1];
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var payRangeString = (0,payRangeHelper/* default */.Z)(payRange.hourlyRateTo.amount, payRange.hourlyRateFrom.amount);
    var isEmbraceTheme = (0,useActiveTheme/* default */.Z)().isEmbraceTheme;
    var personalJoinButtonFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.SEO_1265_PROVIDER_PROFILE_PERSONALIZED_CTA.id */.WV.SEO_1265_PROVIDER_PROFILE_PERSONALIZED_CTA.id);
    var isPersonalJoinButtonTest = (personalJoinButtonFlag === null || personalJoinButtonFlag === void 0 ? void 0 : personalJoinButtonFlag.variationIndex) === 1;
    var joinToContactText = isPersonalJoinButtonTest ? "Contact ".concat(firstName) : "Join to contact";
    var joinNowText = isPersonalJoinButtonTest ? "Contact ".concat(firstName) : "Join now";
    (0,react.useEffect)(function() {
        if (personalJoinButtonFlag && personalJoinButtonFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_1265_PROVIDER_PROFILE_PERSONALIZED_CTA.id */.WV.SEO_1265_PROVIDER_PROFILE_PERSONALIZED_CTA.id,
                test_variant: personalJoinButtonFlag.variationIndex,
                service_id_for_member: serviceIdForMember,
                page_template: pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "National" : "Local"
            });
        }
    });
    var handleJoinToContact = function(e) {
        var amplitudeData = {
            cta_text: e.target.textContent,
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    var handleBackgroundCheck = function() {
        setOpen(true);
        var amplitudeData = {
            cta_intent: "trust badge",
            cta_text: "background check"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        disableGutters: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                sx: classes.profileContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        lg: 6,
                        sx: classes.profileImgSection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, {
                            alt: displayName,
                            sx: classes.profileImgCustomBig,
                            size: "squareMedium",
                            src: hiResImageURL,
                            children: (0,getUserInitials/* getUserInitials */.Z)(displayName)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        lg: 5,
                        sx: classes.profileInfoSection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: classes.profileInfo,
                            children: [
                                availability && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "tag",
                                    sx: classes.profileAvailability,
                                    children: availability === null || availability === void 0 ? void 0 : availability.replace("_", "-")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: isMobileOrSmaller ? "h1" : "display3",
                                    sx: classes.profileTitle,
                                    children: displayName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: classes.profileRating,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                            name: "size-large",
                                            defaultValue: avgReviewRating,
                                            readOnly: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "info1",
                                            color: "secondary",
                                            children: [
                                                "(",
                                                numberOfReviews,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: isMobileOrSmaller ? "body3" : undefined,
                                    children: "".concat(address === null || address === void 0 ? void 0 : address.city, ", ").concat(address === null || address === void 0 ? void 0 : address.state)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    "justify-content": "center",
                                    sx: classes.ageAndExpContainer,
                                    children: [
                                        payRangeString && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: yearsOfExperience > 0 ? 6 : 12,
                                            sx: classes.ageAndExp,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h2",
                                                    children: payRangeString
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body3",
                                                    color: "secondary",
                                                    children: "Hourly rate"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 6,
                                            sx: classes.ageAndExp,
                                            children: yearsOfExperience !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h2",
                                                        children: yearsOfExperience
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body3",
                                                        color: "secondary",
                                                        children: "Years exp."
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                hasCareCheck ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            sx: classes.careBadge,
                                            children: isEmbraceTheme ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                PopperProps: {
                                                    disablePortal: true
                                                },
                                                title: "Completed a Care.com Background Check",
                                                placement: "bottom-start",
                                                arrow: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24ShieldFilled/* default */.Z, {}),
                                                    text: "Background checked",
                                                    sx: {
                                                        ml: 0.5,
                                                        mr: 0,
                                                        cursor: "pointer",
                                                        height: "100%",
                                                        position: "relative",
                                                        top: "3px"
                                                    }
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                                "aria-label": "Background Check",
                                                onClick: handleBackgroundCheck,
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoBgcFilled/* default */.Z, {
                                                    size: "18px"
                                                }),
                                                text: "Background Check"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: joinNowURL,
                                            rel: "nofollow",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                sx: classes.joinBtn,
                                                color: "primary",
                                                onClick: handleJoinToContact,
                                                variant: "contained",
                                                children: joinToContactText
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: joinNowURL,
                                    rel: "nofollow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        sx: classes.joinBtn,
                                        color: "primary",
                                        onClick: handleJoinToContact,
                                        variant: "contained",
                                        children: joinNowText
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeModal, {})
        ]
    });
};
/* harmony default export */ var components_Profile = (Profile);

// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityCheckmark.js
var Icon24UtilityCheckmark = __webpack_require__(37315);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 4 modules
var ListItem = __webpack_require__(70891);
;// CONCATENATED MODULE: ./src/components/Verifications.tsx






var CaregiverVerificationsAttributes;
(function(CaregiverVerificationsAttributes) {
    CaregiverVerificationsAttributes["PHONE_NUMBER_VERIFIED"] = "PHONE_NUMBER_VERIFIED";
    CaregiverVerificationsAttributes["EMAIL_ID_VERIFIED"] = "EMAIL_ID_VERIFIED";
    CaregiverVerificationsAttributes["FACEBOOK_USER_LINKED"] = "FACEBOOK_USER_LINKED";
})(CaregiverVerificationsAttributes || (CaregiverVerificationsAttributes = {}));
var _obj;
var caregiverVerificationsLabels = (_obj = {}, (0,_define_property/* default */.Z)(_obj, CaregiverVerificationsAttributes.PHONE_NUMBER_VERIFIED, "Phone verified"), (0,_define_property/* default */.Z)(_obj, CaregiverVerificationsAttributes.EMAIL_ID_VERIFIED, "Email verified"), (0,_define_property/* default */.Z)(_obj, CaregiverVerificationsAttributes.FACEBOOK_USER_LINKED, "Facebook verified"), _obj);
/* Using this component for highlights and verification is causing issues. For now relaxed the type check. Need to re-visit. */ var Verifications = function(param) {
    var features = param.features, title = param.title;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        sx: {
            pt: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: isMobileOrSmaller ? "h2" : "h1",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        children: features.map(function(feature) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                lg: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                    sx: {
                                        display: "flex",
                                        padding: "6px 0",
                                        lineHeight: "26px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityCheckmark/* default */.Z, {
                                                size: 19,
                                                color: "#027854"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body2",
                                                pl: 2,
                                                fontWeight: "bold",
                                                children: caregiverVerificationsLabels[feature]
                                            })
                                        ]
                                    })
                                })
                            }, feature);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_Verifications = (Verifications);

// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(50456);
// EXTERNAL MODULE: ./src/components/ReadMore.tsx
var ReadMore = __webpack_require__(35492);
;// CONCATENATED MODULE: ./src/components/ProviderIntro.tsx




var classes = {
    bullets: {
        textTransform: "capitalize",
        display: "list-item",
        float: "left",
        marginLeft: "30px",
        "&::marker": {
            color: "care.blue.300"
        },
        "&:first-of-type": {
            display: "inline-block",
            marginLeft: "0px"
        }
    }
};
var mappedLanguages = {
    AFRIKAANS: "Afrikaans",
    ALBANIAN: "Albanian",
    ARABIC: "Arabic",
    ARMENIAN: "Armenian",
    AZERBAIJANI: "Azerbaijani",
    BELARUSIAN: "Belarusian",
    BENGALI: "Bengali",
    BOSNIAN: "Bosnian",
    BULGARIAN: "Bulgarian",
    CAMBODIAN: "Cambodian",
    CATALAN: "Catalan",
    CHINESE: "Chinese",
    CROATIAN: "Croatian",
    CZECH: "Czech",
    DANISH: "Danish",
    DUTCH: "Dutch",
    ENGLISH: "English",
    ESTONIAN: "Estonian",
    FINNISH: "Finnish",
    FRENCH: "French",
    GEORGIAN: "Georgian",
    GERMAN: "German",
    GREEK: "Greek",
    HEBREW: "Hebrew",
    HINDI: "Hindi",
    HUNGARIAN: "Hungarian",
    ICELANDIC: "Icelandic",
    INDONESIAN: "Indonesian",
    ITALIAN: "Italian",
    JAPANESE: "Japanese",
    KAZAKH: "Kazakh",
    KOREAN: "Korean",
    KURDISH: "Kurdish",
    LAOTIAN: "Laotian",
    LATVIAN: "Latvian",
    LITHUANIAN: "Lithuanian",
    MADARIN: "Mandarin",
    MALAY: "Malay",
    MANDARIN: "Mandarin",
    MOLDAVIAN: "Moldavian",
    MONGOLIAN: "Mongolian",
    NEPALI: "Nepali",
    NORWEGIAN: "Norwegian",
    PERSIAN: "Persian",
    POLISH: "Polish",
    PORTUGUESE: "Portuguese",
    PORTUGUESE_BRAZIL: "Brazilian Portuguese",
    PUNJABI: "Punjabi",
    ROMANIAN: "Romanian",
    RUSSIAN: "Russian",
    SERBIAN: "Serbian",
    SERBO_CROATIAN: "Serbo Croatian",
    SESOTHO: "Sesotho",
    SIGN_ASL: "Sign (ASL)",
    SIGN_LANGUAGE_ASL: "Sign Language (ASL)",
    SIGN_LANGUAGE_SEE: "Sign Language (SEE)",
    SIGN_SEE: "Sign (SEE)",
    SINDHI: "Sindhi",
    SLOVAK: "Slovak",
    SLOVENIAN: "Slovenian",
    SOMALI: "Somali",
    SPANISH: "Spanish",
    SUDANESE: "Sudanese",
    SWAHILI: "Swahili",
    SWEDISH: "Swedish",
    TAGALOG: "Tagalog",
    TAJIK: "Tajik",
    TAMIL: "Tamil",
    TELUGU: "Telugu",
    THAI: "Thai",
    TONGA: "Tonga",
    TURKISH: "Turkish",
    UKRAINIAN: "Ukrainian",
    UKRANIAN: "Ukranian",
    URDU: "Urdu",
    UZBEK: "Uzbek",
    VIETNAMESE: "Vietnamese",
    YIDDISH: "Yiddish",
    ZULU: "Zulu"
};
var ProviderIntro = function(param) {
    var memberDetail = param.memberDetail, profileDesc = param.profileDesc;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            pt: {
                xs: 1,
                md: 4
            },
            pb: 3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: isMobileOrSmaller ? "h2" : "h1",
                    mb: 2,
                    textAlign: {
                        md: "left"
                    },
                    children: [
                        "Meet ",
                        memberDetail.firstName
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    flexWrap: "wrap",
                    mb: 3,
                    width: "100%",
                    children: [
                        memberDetail.age !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h4",
                            sx: classes.bullets,
                            children: [
                                memberDetail.age,
                                "yrs"
                            ]
                        }),
                        memberDetail.gender && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            sx: classes.bullets,
                            children: memberDetail.gender.toLowerCase()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h4",
                            sx: classes.bullets,
                            children: [
                                "Speaks",
                                " ",
                                memberDetail.languages.map(function(language, index) {
                                    if (memberDetail.languages.length - 1 > index) return "".concat(mappedLanguages[language], ", ");
                                    return mappedLanguages[language];
                                })
                            ]
                        })
                    ]
                }),
                profileDesc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    implementation: "css",
                    smUp: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                        gutterBottom: true,
                        component: "div",
                        variant: "body2",
                        charLimit: 155,
                        value: profileDesc,
                        showMoreLabel: "more"
                    })
                }),
                profileDesc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                    implementation: "css",
                    smDown: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        children: profileDesc
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_ProviderIntro = (ProviderIntro);

;// CONCATENATED MODULE: ./src/components/CanAlsoHelpWith.tsx



var CanAlsoHelpWith = function(param) {
    var sideJobsList = param.sideJobsList, firstName = param.firstName;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        sx: {
            pt: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: isMobileOrSmaller ? "h2" : "h1",
                mb: 2,
                children: [
                    firstName,
                    " can also help with:"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                children: sideJobsList.map(function(value) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            fontSize: "body2.fontSize",
                            display: "list-item",
                            mx: 2.5,
                            my: 1,
                            "data-testid": "can-help-list",
                            children: value
                        })
                    }, value);
                })
            })
        ]
    });
};
/* harmony default export */ var components_CanAlsoHelpWith = (CanAlsoHelpWith);

// EXTERNAL MODULE: ./src/utils/dateMonthYearFormat.ts
var dateMonthYearFormat = __webpack_require__(42182);
;// CONCATENATED MODULE: ./src/components/RecentReview.tsx







var RecentReview = function(param) {
    var latestReview = param.latestReview, numOfReviews = param.numOfReviews, joinNowURL = param.joinNowURL;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var handleReadAllReviews = function() {
        var amplitudeData = {
            cta_text: "Read all reviews",
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        sx: {
            pt: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: isMobileOrSmaller ? "h2" : "h1",
                component: "h2",
                mb: 3,
                children: "Most recent review"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                width: "330px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, {
                            size: "large",
                            src: latestReview.reviewer.imageURL,
                            children: (0,getUserInitials/* getUserInitials */.Z)(latestReview.reviewer.displayName)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 10,
                        pl: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: isMobileOrSmaller ? "h5" : "h4",
                                mb: 1,
                                children: latestReview.reviewer.displayName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                name: "size-large",
                                defaultValue: latestReview.rating,
                                readOnly: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: isMobileOrSmaller ? "info1" : "body3",
                                children: [
                                    (0,dateMonthYearFormat/* default */.Z)({
                                        dateTime: latestReview.reviewDate,
                                        useOrdinalDay: true,
                                        useFullDate: true
                                    }),
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                my: 2,
                mx: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    children: latestReview.comment
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "info1",
                color: "care.grey.700",
                children: [
                    "Showing results 1 of ",
                    numOfReviews
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                textAlign: "center",
                mt: 3,
                mb: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: joinNowURL,
                    rel: "nofollow",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "flexible",
                        color: "secondary",
                        onClick: handleReadAllReviews,
                        variant: "outlined",
                        children: "Read all reviews"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_RecentReview = (RecentReview);

;// CONCATENATED MODULE: ./src/components/CaregiverEducation.tsx



var Education = function(param) {
    var collegeDegrees = param.collegeDegrees;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var degreeeAndYearHelper = function(degree, degreeYear) {
        if (degree && degreeYear) {
            return "".concat(degree, ", ").concat(degreeYear);
        }
        if (degree) {
            return degree;
        }
        return degreeYear;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "md",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                pb: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: isMobileOrSmaller ? "h2" : "h1",
                        children: "Education"
                    }),
                    collegeDegrees.map(function(param) {
                        var collegeName = param.collegeName, degree = param.degree, degreeYear = param.degreeYear;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                collegeName !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h4",
                                    mt: 3,
                                    children: collegeName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "secondary",
                                    children: degreeeAndYearHelper(degree, degreeYear)
                                })
                            ]
                        }, "".concat(degree, "-").concat(degreeYear));
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CaregiverEducation = (Education);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/SimilarProfiles.tsx








var SimilarProfiles_classes = {
    similarProfileContainer: {
        marginTop: 4
    },
    gridContainer: function(theme) {
        return (0,_define_property/* default */.Z)({
            maxWidth: "328px",
            margin: "auto",
            textAlign: "center"
        }, theme.breakpoints.up("md"), {
            maxWidth: "960px",
            textAlign: "left"
        });
    },
    similarProfileInfo: {
        display: "block"
    },
    profileSection: function(theme) {
        return (0,_define_property/* default */.Z)({
            marginTop: 3,
            cursor: "pointer",
            display: "block",
            "& a": {
                textDecoration: "none",
                color: theme.palette.care.grey[900]
            }
        }, theme.breakpoints.up("sm"), {
            maxWidth: "100px",
            textAlign: "center"
        });
    },
    similarProfileImg: {
        display: "flex",
        justifyContent: "center"
    },
    profileName: function(theme) {
        return (0,_define_property/* default */.Z)({
            marginTop: theme.spacing(1)
        }, theme.breakpoints.up("sm"), {
            marginTop: theme.spacing(1.5)
        });
    }
};
var SimilarProfiles = function(param) {
    var profiles = param.profiles;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        sx: SimilarProfiles_classes.similarProfileContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: isMobileOrSmaller ? "h2" : "h1",
                children: "Similar caregivers nearby"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                sx: SimilarProfiles_classes.gridContainer,
                children: profiles.map(function(profile, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: profile.profileURL && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            md: 2,
                            xs: 6,
                            display: profiles.length === index + 1 && isMobileOrSmaller ? "none" : "block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: SimilarProfiles_classes.profileSection,
                                "data-testid": "similar-profiles",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: profile.profileURL,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: profile.profileURL,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: SimilarProfiles_classes.similarProfileImg,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, {
                                                    alt: "profile",
                                                    src: profile.member.imageURL,
                                                    size: "xLarge",
                                                    children: (0,getUserInitials/* getUserInitials */.Z)(profile.member.displayName)
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                sx: SimilarProfiles_classes.similarProfileInfo,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h4",
                                                        sx: SimilarProfiles_classes.profileName,
                                                        children: profile.member.displayName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                                            name: "size-large",
                                                            size: "small",
                                                            defaultValue: profile.avgReviewRating,
                                                            readOnly: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "info1",
                                                        color: "secondary",
                                                        children: profile.member.address.city
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }, profile.member.displayName);
                })
            })
        ]
    });
};
/* harmony default export */ var components_SimilarProfiles = (SimilarProfiles);

// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandBabysitters.js
var Icon48BrandBabysitters = __webpack_require__(47926);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandNannies.js
var Icon48BrandNannies = __webpack_require__(77649);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandTutoring.js
var Icon48BrandTutoring = __webpack_require__(54682);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandHousekeeping.js
var Icon48BrandHousekeeping = __webpack_require__(97521);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandPetCare.js
var Icon48BrandPetCare = __webpack_require__(66860);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon48BrandSeniorCare.js
var Icon48BrandSeniorCare = __webpack_require__(99344);
;// CONCATENATED MODULE: ./src/components/CareOptions.tsx





var CareOptions_classes = {
    jobListContainer: function(theme) {
        return (0,_define_property/* default */.Z)({
            cursor: "pointer",
            margin: theme.spacing(2, 1.5, 1.5, 1.5)
        }, theme.breakpoints.up("md"), {
            margin: 2,
            "&:first-of-type": {
                marginLeft: 0
            }
        });
    },
    sideJobIcon: {
        width: "88px",
        height: "88px",
        border: "1px solid",
        borderColor: "care.grey.300",
        borderRadius: 3,
        display: "inline-block",
        padding: 2.5,
        "& svg": {
            width: "48px",
            height: "48px"
        }
    },
    careOptionsName: {
        color: "care.navy.900",
        textDecoration: "none",
        display: "block",
        cursor: "pointer",
        width: "90px",
        marginTop: "10px",
        lineHeight: "22px"
    }
};
/* This is a static list */ var optionsList = [
    {
        id: 1,
        name: "Babysitters",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandBabysitters/* default */.Z, {}),
        verticalURL: "/babysitters"
    },
    {
        id: 2,
        name: "Nannies",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandNannies/* default */.Z, {}),
        verticalURL: "/nannies"
    },
    {
        id: 3,
        name: "Tutoring",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandTutoring/* default */.Z, {}),
        verticalURL: "/tutors"
    },
    {
        id: 4,
        name: "House keeping",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandHousekeeping/* default */.Z, {}),
        verticalURL: "/housekeepers"
    },
    {
        id: 5,
        name: "Pet care",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandPetCare/* default */.Z, {}),
        verticalURL: "/pet-care"
    },
    {
        id: 6,
        name: "Senior care",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon48BrandSeniorCare/* default */.Z, {}),
        verticalURL: "/senior-care"
    }, 
];
var CareOptions = function(param) {
    var hasCareCheck = param.hasCareCheck;
    var isMobileOrSmaller = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                pt: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: isMobileOrSmaller ? "h4" : "h2",
                        color: "secondary",
                        mt: 1,
                        children: "Or take a look at some other care options"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: "flex",
                        mb: {
                            xs: 3,
                            md: 0
                        },
                        flexWrap: "wrap",
                        justifyContent: {
                            xs: "center",
                            md: "flex-start"
                        },
                        textAlign: "center",
                        children: optionsList.map(function(option) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: CareOptions_classes.jobListContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                    sx: {
                                        ".MuiTypography-root": {
                                            display: "block"
                                        }
                                    },
                                    href: option.verticalURL,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: CareOptions_classes.sideJobIcon,
                                            children: option.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: CareOptions_classes.careOptionsName,
                                            variant: "h4",
                                            children: option.name
                                        })
                                    ]
                                })
                            }, option.id);
                        })
                    })
                ]
            }),
            !hasCareCheck && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                my: 2,
                mx: 0,
                width: "75%",
                children: "Caregiver profile is illustrative only. This caregiver may not have a current, active account or background check. Care.com members can access active, background checked caregivers."
            })
        ]
    });
};
/* harmony default export */ var components_CareOptions = (CareOptions);

// EXTERNAL MODULE: ./src/components/SeoConversionBox.tsx
var SeoConversionBox = __webpack_require__(58291);
// EXTERNAL MODULE: ./src/components/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(22284);
// EXTERNAL MODULE: ./src/components/SeoGlobalNavbar.tsx
var SeoGlobalNavbar = __webpack_require__(8410);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoSuccess.js
var Icon24InfoSuccess = __webpack_require__(92176);
;// CONCATENATED MODULE: ./src/components/Highlights.tsx



var Highlights_classes = {
    highlightsContainer: {
        paddingTop: 1
    },
    highlightsInfo: {
        marginTop: 2
    },
    highlightsList: {
        display: "flex",
        padding: "0",
        lineHeight: "22px",
        minHeight: "36px",
        alignItems: "start"
    },
    leftTickIcon: {
        width: "20px",
        height: "20px",
        marginTop: "1px",
        color: "care.green.800"
    },
    highlightsText: {
        paddingLeft: 2,
        fontWeight: "bold"
    }
};
var Highlights = function(param) {
    var qualities = param.qualities;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        sx: Highlights_classes.highlightsContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    children: "Highlights"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                children: qualities.map(function(quality) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        lg: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                            sx: Highlights_classes.highlightsList,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoSuccess/* default */.Z, {
                                        sx: Highlights_classes.leftTickIcon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: Highlights_classes.highlightsText,
                                        children: quality
                                    })
                                ]
                            })
                        })
                    }, quality);
                })
            })
        ]
    });
};
/* harmony default export */ var components_Highlights = (Highlights);

// EXTERNAL MODULE: ./src/components/CaregiverZipCodeCTA.tsx
var CaregiverZipCodeCTA = __webpack_require__(94989);
// EXTERNAL MODULE: ./src/utils/generateEnrollmentUrl.ts + 1 modules
var generateEnrollmentUrl = __webpack_require__(85715);
// EXTERNAL MODULE: ./src/utils/getProviderMetadata.ts
var getProviderMetadata = __webpack_require__(56897);
// EXTERNAL MODULE: ./src/utils/mapQualitiesAndServices.ts
var mapQualitiesAndServices = __webpack_require__(94627);
// EXTERNAL MODULE: ./src/components/CaregiverProfile/ProfilePageSchema.tsx
var ProfilePageSchema = __webpack_require__(99014);
// EXTERNAL MODULE: ./src/components/pages/segmentationDetails/caregiver/hooks/useAmplitudeTracking.ts
var useAmplitudeTracking = __webpack_require__(37187);
// EXTERNAL MODULE: ./src/components/pages/segmentationDetails/caregiver/hooks/useMetaTags.ts
var useMetaTags = __webpack_require__(54847);
// EXTERNAL MODULE: ./src/components/pages/segmentationDetails/caregiver/shared/MetaHead.tsx
var MetaHead = __webpack_require__(12800);
;// CONCATENATED MODULE: ./src/components/pages/segmentationDetails/caregiver/CaregiverDetail.tsx




























var ref = config_default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var CaregiverDetail = function(param) {
    var data = param.pageData, serviceShortName = param.serviceShortName, testName = param.testName, deviceChar = param.deviceChar, seoSegmentId = param.seoSegmentId;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var hasCareCheck = data === null || data === void 0 ? void 0 : data.getSEOSegmentationCaregiverDetails.caregiver.hasCareCheck;
    var ref6;
    var hasAiBio = (ref6 = (ref1 = (ref = data === null || data === void 0 ? void 0 : data.getSEOSegmentationCaregiverDetails.caregiver.profiles) === null || ref === void 0 ? void 0 : ref.commonCaregiverProfile.bio) === null || ref1 === void 0 ? void 0 : ref1.aiAssistedBio) !== null && ref6 !== void 0 ? ref6 : false;
    (0,useAmplitudeTracking/* default */.Z)({
        deviceChar: deviceChar,
        testName: testName,
        hasCareCheck: hasCareCheck,
        serviceShortName: serviceShortName,
        hasAiBio: hasAiBio
    });
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var ref7 = (data === null || data === void 0 ? void 0 : data.getSEOSegmentationCaregiverDetails) || {}, caregiver = ref7.caregiver, latestCaregiverReview = ref7.latestCaregiverReview, nearByCaregivers = ref7.nearByCaregivers;
    var memberInfo = caregiver === null || caregiver === void 0 ? void 0 : caregiver.member;
    var breadcrumbs = (data === null || data === void 0 ? void 0 : data.getSEOSegmentationBreadcrumbs.breadcrumbs) || [];
    var caregiverProfile = (ref2 = caregiver.profiles) === null || ref2 === void 0 ? void 0 : ref2.commonCaregiverProfile;
    var seoProfileUrl = NEXT_PUBLIC_APP_URL + seoSegmentId;
    var _numberOfReviews;
    var providerMetadata = (0,getProviderMetadata/* default */.Z)({
        displayName: memberInfo === null || memberInfo === void 0 ? void 0 : memberInfo.displayName,
        firstName: memberInfo.firstName,
        address: {
            city: memberInfo === null || memberInfo === void 0 ? void 0 : memberInfo.address.city,
            state: memberInfo === null || memberInfo === void 0 ? void 0 : memberInfo.address.state
        },
        yearsOfExperience: caregiver === null || caregiver === void 0 ? void 0 : caregiver.yearsOfExperience,
        availability: caregiverProfile === null || caregiverProfile === void 0 ? void 0 : caregiverProfile.availabilityFrequency,
        // render Care's logo if provider doesn't have profile picture
        image: (memberInfo === null || memberInfo === void 0 ? void 0 : memberInfo.hiResImageURL) ? memberInfo.hiResImageURL : "".concat(NEXT_PUBLIC_APP_URL, "/img/care-no-tag.jpg"),
        serviceName: constants/* SEO_SERVICE_MAP_SHORT_NAMES */.yA[serviceShortName],
        hourlyRate: caregiverProfile === null || caregiverProfile === void 0 ? void 0 : (ref3 = caregiverProfile.payRange) === null || ref3 === void 0 ? void 0 : ref3.hourlyRateFrom.amount,
        bio: (caregiverProfile === null || caregiverProfile === void 0 ? void 0 : (ref4 = caregiverProfile.bio) === null || ref4 === void 0 ? void 0 : ref4.experienceSummary) || null,
        totalReviews: (_numberOfReviews = caregiver.numberOfReviews) !== null && _numberOfReviews !== void 0 ? _numberOfReviews : 0,
        isPremium: caregiverProfile.isPremium
    });
    var caregiverQualities = caregiverProfile ? (0,mapQualitiesAndServices/* default */.Z)(caregiverProfile.qualities) : [];
    var caregiverServices = caregiverProfile ? (0,mapQualitiesAndServices/* default */.Z)(caregiverProfile.supportedServices) : [];
    var enrollmentURL = (0,generateEnrollmentUrl/* default */.Z)({
        serviceShortName: serviceShortName,
        serviceIdForMember: memberInfo === null || memberInfo === void 0 ? void 0 : memberInfo.subService
    });
    var handleJoinFreeToSeeProfile = function(e) {
        var amplitudeData = {
            cta_text: e.target.textContent,
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    var metaTags = (0,useMetaTags/* default */.Z)(providerMetadata);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaHead/* default */.Z, {
                pageTitle: providerMetadata.title,
                metaTags: metaTags,
                seoProfileUrl: seoProfileUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePageSchema/* ProfilePageSchema */.q, {
                displayName: memberInfo.displayName,
                description: providerMetadata.description,
                imageURL: providerMetadata.image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* default */.Z, {
                enrollmentURL: enrollmentURL
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                mb: 8,
                children: [
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            maxWidth: "md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                                breadcrumbs: breadcrumbs
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            maxWidth: "md",
                            disableGutters: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaregiverZipCodeCTA/* default */.Z, {
                                enrollmentURL: enrollmentURL,
                                serviceShortName: serviceShortName
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Profile, {
                            displayName: memberInfo.displayName,
                            firstName: memberInfo.firstName,
                            address: memberInfo.address,
                            hiResImageURL: memberInfo.hiResImageURL,
                            joinNowURL: "".concat(enrollmentURL, "&visitedServiceProfileId=").concat(caregiverProfile.id),
                            hasCareCheck: caregiver.hasCareCheck,
                            numberOfReviews: caregiver.numberOfReviews,
                            yearsOfExperience: caregiver.yearsOfExperience,
                            avgReviewRating: caregiver.avgReviewRating,
                            payRange: caregiverProfile.payRange,
                            availability: caregiverProfile.availabilityFrequency
                        })
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoConversionBox/* default */.Z, {
                            header: "When do you need care?",
                            enrollmentURL: enrollmentURL
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            sx: {
                                py: 1
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProviderIntro, {
                            memberDetail: caregiver.member,
                            profileDesc: caregiverProfile.bio.experienceSummary
                        })
                    }),
                    (caregiverQualities === null || caregiverQualities === void 0 ? void 0 : caregiverQualities.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Highlights, {
                            qualities: caregiverQualities
                        })
                    }),
                    (caregiverServices === null || caregiverServices === void 0 ? void 0 : caregiverServices.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                maxWidth: "md",
                                disableGutters: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                    sx: {
                                        py: 1
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CanAlsoHelpWith, {
                                    firstName: memberInfo.firstName,
                                    sideJobsList: caregiverServices
                                })
                            })
                        ]
                    }),
                    latestCaregiverReview && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                maxWidth: "md",
                                disableGutters: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                    sx: {
                                        py: 1
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                id: "recentReview",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RecentReview, {
                                    latestReview: latestCaregiverReview,
                                    numOfReviews: caregiver.numberOfReviews,
                                    joinNowURL: enrollmentURL
                                })
                            })
                        ]
                    }),
                    ((ref5 = caregiver.collegeDegrees) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                maxWidth: "md",
                                disableGutters: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                    sx: {
                                        py: 1
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaregiverEducation, {
                                collegeDegrees: caregiver.collegeDegrees
                            })
                        ]
                    }),
                    caregiver.verifications && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                maxWidth: "md",
                                disableGutters: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                    sx: {
                                        py: 1
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Verifications, {
                                    features: caregiver.verifications,
                                    title: "Verified information"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            m: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                textAlign: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: enrollmentURL,
                                    rel: "nofollow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "primary",
                                        variant: "contained",
                                        size: "large",
                                        onClick: handleJoinFreeToSeeProfile,
                                        sx: {
                                            width: "324px"
                                        },
                                        children: caregiver.hasCareCheck ? "Join free to see full profile" : "Join now"
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: (nearByCaregivers === null || nearByCaregivers === void 0 ? void 0 : nearByCaregivers.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SimilarProfiles, {
                            profiles: nearByCaregivers
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CareOptions, {
                            hasCareCheck: caregiver.hasCareCheck
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoConversionBox/* default */.Z, {
                                    header: "When do you need care?",
                                    enrollmentURL: enrollmentURL
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                                        breadcrumbs: breadcrumbs
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var caregiver_CaregiverDetail = (CaregiverDetail);


/***/ }),

/***/ 42182:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/*
 * date conversion to one of the following example formats:
 * Apr 2023
 * April 2023
 * Apr 25, 2023
 * April 25, 2023
 * Apr 25th, 2023
 * April 25th, 2023
 */ // Add postfix like 3rd, 4th, 22nd to the date
var getOrdinalNum = function(n) {
    return n + (n > 0 ? [
        "th",
        "st",
        "nd",
        "rd"
    ][n > 3 && n < 21 || n % 10 > 3 ? 0 : n % 10] : "");
};
var dateMonthYearFormat = function(param) {
    var dateTime = param.dateTime, _useLongMonth = param.useLongMonth, useLongMonth = _useLongMonth === void 0 ? false : _useLongMonth, _useOrdinalDay = param.useOrdinalDay, useOrdinalDay = _useOrdinalDay === void 0 ? false : _useOrdinalDay, _useFullDate = param.useFullDate, useFullDate = _useFullDate === void 0 ? false : _useFullDate;
    var date = new Date(dateTime);
    var dayOftheMonth = useOrdinalDay ? "".concat(getOrdinalNum(date.getUTCDate())) : date.getUTCDate();
    var month = useLongMonth ? date.toLocaleString("en-US", {
        month: "long"
    }) : date.toLocaleString("en-US", {
        month: "short"
    });
    var year = date.getUTCFullYear();
    return useFullDate ? "".concat(month, " ").concat(dayOftheMonth, ", ").concat(year) : "".concat(month, " ").concat(year);
};
/* harmony default export */ __webpack_exports__["Z"] = (dateMonthYearFormat);


/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

}]);